import axios from "axios";

export default {
    FETCH_HEAT_SOLAR(postData) {
        return axios.post('/solar_calculator/solar_irradiance/',postData);
    }
}